// @flow

import common from './locales/ru/common.json'

export const ru = { common }

export default ru
